module.exports = __webpack_public_path__ + "img/openweb.e838c325.png";